const lastAction = (state = '', action) => {
  return action.type;
}

export default lastAction;
